import { ReactNode } from 'react';
import { Text } from '@connect-x-app/hybrid-ui';
import { IconName } from '@connect-x-app/shared-types';
import { LAYERS } from '@connect-x-app/shared-ui';
import { partTestId } from '@connect-x-app/shared-utils';
import classnames from 'classnames';

import { Icon } from '../icon';
import { IconWithTooltip } from '../iconWithTooltip';

import './Block.scss';

const LEADING_ICON_SIZE = 2.2;
const CHEVRON_SIZE = 2.4;
const LABEL_ICON_SIZE = 1.6;
const ICON_COLOR = LAYERS.iconColors['$icon-primary'];

type Props = {
  className?: string;
  icon?: IconName;
  indented?: boolean;
  isDisabled?: boolean;
  label: string;
  labelIcon?: IconName;
  onClick?: () => void;
  testId?: string;
  tooltip?: string;
  trailing?: ReactNode;
};

export const BlockRow = ({
  className,
  icon,
  indented,
  isDisabled,
  label,
  labelIcon,
  onClick,
  testId,
  tooltip,
  trailing,
}: Props) => {
  const rowClassName = classnames(
    'block-row',
    {
      'block-row--clickable': !!onClick && !isDisabled,
      'block-row--disabled': !!isDisabled,
      'block-row--indented': !!indented,
    },
    className,
  );

  const content = (
    <>
      <span className="block-row__leading">
        {icon ? <Icon colorName={ICON_COLOR} name={icon} size={LEADING_ICON_SIZE} testId={partTestId(testId, 'icon')} /> : null}
        <Text as="span" className="block-row__label" size="SM" uppercase weight="bold">
          {label}
        </Text>
        {labelIcon && tooltip ? (
          <IconWithTooltip
            colorName={ICON_COLOR}
            iconName={labelIcon}
            label={tooltip}
            size={LABEL_ICON_SIZE}
            testId={partTestId(testId, 'labelIcon')}
          />
        ) : null}
      </span>
      <span className="block-row__trailing">
        {trailing}
        {onClick ? (
          <Icon colorName={ICON_COLOR} name="chevronRight" size={CHEVRON_SIZE} testId={partTestId(testId, 'chevron')} />
        ) : null}
      </span>
    </>
  );

  if (onClick) {
    return (
      <button className={rowClassName} data-test={testId} disabled={isDisabled} onClick={onClick} type="button">
        {content}
      </button>
    );
  }

  return (
    <div className={rowClassName} data-test={testId}>
      {content}
    </div>
  );
};
